export default __webpack_public_path__ + "static/media/linkedin.41b11a74.svg";